<template>
  <HoverTooltip :position="position">
    <template #subject>
      <div
        class="flex justify-center items-center flex-none w-auto mb-0 font-medium rounded-full text-white bg-green-300 px-1.5 py-2.5"
        :style="{
          paddingTop: isMobile ? '0.125rem' : '0.375rem',
          paddingBottom: isMobile ? '0.125rem' : '0.375rem',
          paddingLeft: isMobile ? '0.5rem' : '0.625rem',
          paddingRight: isMobile ? '0.5rem' : '0.625rem',
        }"
      >
        <Icon name="mortar-board" class="ds-text-2xs md:ds-text-xs" />
        <p class="block ml-1 ds-text-2xs md:ds-text-xs">Interested</p>
      </div>
    </template>
    <template #tooltip>
      <p class="ds-text-2xs md:ds-text-xs">
        They’re interested in your school!
      </p>
    </template>
  </HoverTooltip>
</template>

<script>
import { HoverTooltip, Icon } from "@sportsrecruits/playbook";

export default {
  components: { HoverTooltip, Icon },
  props: {
    position: {
      type: String,
      default: "top",
    },
  },
  computed: {
    isMobile() {
      return ["xs", "sm", "mobile"].includes(this.$mq);
    },
  },
}

</script>

<style scoped>
.px-1.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}

.py-2.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
</style>
